<template>
	<div style="position: relative;">
		<div
			class="asticle_l_title_item littleTitle flexRow"
			style="margin-bottom: 20px;"
		>
			<img src="../../../../assets/main/title_icon.jpg" alt="" />
			<a
				@click="clicktabfn('/trancolumn?id=77&name=交易数据')"
				href="javascript:void(0);"
				class="spanA"
				>碳排放交易市场行情</a
			>
			<i></i>
			<div class="shuangtan_l_tab_smbox">
				<a
					ref="fetchDataJYSJ_1"
					@click="clicktabfn('/trancolumn?id=77&name=交易数据')"
					@mouseover="fetchDataJYSJ(true, 'fetchDataJYSJ_1')"
					href="javascript:void(0);"
					>全国</a
				><span class="fetchDatashu">|</span>
				<a
					ref="fetchDataJYSJ_2"
					@click="clicktabfn('/trancolumn?id=77&name=交易数据')"
					@mouseover="fetchDataJYSJ(false, 'fetchDataJYSJ_2')"
					href="javascript:void(0);"
					>地方</a
				>
			</div>
			<a
				class="article_l_more"
				@click="clicktabfn('/trancolumn?id=77&name=交易数据', true)"
				href="javascript:void(0);"
				>更多<img src="../../../../assets/main/more.png" alt=""
			/></a>
		</div>
		<el-dropdown
			@command="handleCommand"
			size="mini"
			trigger="click"
			class="el-dropdown-my"
			style="color: #439238;margin-left:10px;"
		>
			<span class="el-dropdown-link">
				{{ chooseYear
				}}<i class="el-icon-arrow-down el-icon--right"></i>
			</span>
			<el-dropdown-menu slot="dropdown">
				<el-dropdown-item
					v-for="(item, index) in allYears"
					:key="index"
					:command="item"
					>{{ item }}</el-dropdown-item
				>
			</el-dropdown-menu>
		</el-dropdown>
		<div
			v-show="show"
			class="article_r_echarts_Lines"
			id="article_r_echarts_Lines"
		></div>
		<div
			v-show="!show"
			class="article_r_echarts_box"
			id="article_r_echarts_box"
		></div>
	</div>
</template>
<script>
import api from '@/../static/common/api/api.js';
export default {
	name: '',
	components: {},
	mixins: [],
	props: {},
	data() {
		return {
			chooseYear: '2024', //碳排放交易数据选择年份
			allYears: [], //碳排放交易数据全部年份
			allYearsTemplt: [], //碳排放交易数据全部年份备份
			show: true,
			urlHost: window.location.host,
		};
	},
	computed: {},
	watch: {},
	mounted() {
		this.fetchEchartsDataKLines();
		this.fetchAllYears(); //获取碳排放交易数据-全部年份
	},
	methods: {
		//
		fetchDataJYSJ(flag, name) {
			this.show = flag;
			if (name) {
				let tmp = name.split('_');
				this.$refs[tmp[0] + '_' + 1].style.color = '#1C1C1C';
				this.$refs[tmp[0] + '_' + 2].style.color = '#1C1C1C';
				this.$refs[name].style.color = '#55BE48';
			}

			// let param = { uid: _uid, pagesize: 9, curpage: 1 };
			// api.getDocList(param).then((res) => {
			// 	this.zcfg = res.data;
			// });
			if (flag) {
				this.allYears = this.allYears.filter(
					(year) => parseInt(year) >= 2021
				);
			} else {
				this.allYears = this.allYearsTemplt;
			}
		},
		//碳排放交易数据选择年份
		handleCommand(command) {
			this.chooseYear = command;
			this.fetchEchartsData();
			this.fetchEchartsDataKLines();
		},
		//获取碳排放交易数据-全部年份
		fetchAllYears() {
			api.getYears().then((res) => {
				if (this.show) {
					this.allYears = res.data.filter(
						(year) => parseInt(year) >= 2021
					);
				} else {
					this.allYears = res.data;
				}
				this.allYearsTemplt = res.data;
				this.chooseYear = res.data[0];
				this.fetchEchartsData(); //获取碳排放交易数据
				this.fetchEchartsDataKLines();

				// //console.log(this.allYears,'allYears');
			});
		},
		//获取碳排放交易数据-地方
		fetchEchartsData() {
			var chartDom = document.getElementById('article_r_echarts_box');
			var myChart = this.$echarts.init(chartDom);
			var option;

			option = {
				tooltip: {
					trigger: 'axis',
					formatter: function(params) {
						var tipText = '';
						tipText +=
							'<span style="display:block;width:100%;padding:0 10px; margin-bottom:20px;font-size: 14px;font-family: Source Han Sans CN;font-weight: 500;">' +
							params[0].axisValue +
							'</span>';

						for (let index = 0; index < params.length; index++) {
							const element = params[index];
							tipText +=
								'<span style="display:block;width:100%;margin-bottom:15px;padding:0 10px;font-size: 12px;font-family: Source Han Sans CN;font-weight: 500;">' +
								element.marker +
								element.data.region +
								' 成交价：' +
								element.data.value +
								'元/吨 成交量：' +
								element.data.volume +
								'吨</span>';
						}
						// params.forEach(function(item, index) {
						// 	if (index % 5 == 0) {
						// 		tipText +=
						// 			'<span style="display:block;width:100%;margin-bottom:15px;padding:0 10px;font-size: 12px;font-family: Source Han Sans CN;font-weight: 500;"><i style="width: 10px;height: 10px;background: #907DCD;border-radius: 50%;display:inline-block;margin-right:8px;"></i>' +
						// 			item.data.region +
						// 			' 成交价：' +
						// 			item.data.value +
						// 			'元 成交量：' +
						// 			item.data.volume +
						// 			'吨</span>';
						// 	}
						// 	if (index % 5 == 1) {
						// 		tipText +=
						// 			'<span style="display:block;width:100%;margin-bottom:15px;padding:0 10px;font-size: 12px;font-family: Source Han Sans CN;font-weight: 500;"><i style="width: 10px;height: 10px;background: #FF7C08;border-radius: 50%;display:inline-block;margin-right:8px;"></i>' +
						// 			item.data.region +
						// 			' 成交价：' +
						// 			item.data.value +
						// 			'元 成交量：' +
						// 			item.data.volume +
						// 			'吨</span>';
						// 	}
						// 	if (index % 5 == 2) {
						// 		tipText +=
						// 			'<span style="display:block;width:100%;margin-bottom:15px;padding:0 10px;font-size: 12px;font-family: Source Han Sans CN;font-weight: 500;"><i style="width: 10px;height: 10px;background: #FFC428;border-radius: 50%;display:inline-block;margin-right:8px;"></i>' +
						// 			item.data.region +
						// 			' 成交价：' +
						// 			item.data.value +
						// 			'元 成交量：' +
						// 			item.data.volume +
						// 			'吨</span>';
						// 	}
						// 	if (index % 5 == 3) {
						// 		tipText +=
						// 			'<span style="display:block;width:100%;margin-bottom:15px;padding:0 10px;font-size: 12px;font-family: Source Han Sans CN;font-weight: 500;"><i style="width: 10px;height: 10px;background: #5AC04D;border-radius: 50%;display:inline-block;margin-right:8px;"></i>' +
						// 			item.data.region +
						// 			' 成交价：' +
						// 			item.data.value +
						// 			'元 成交量：' +
						// 			item.data.volume +
						// 			'吨</span>';
						// 	}
						// 	if (index % 5 == 4) {
						// 		tipText +=
						// 			'<span style="display:block;width:100%;margin-bottom:15px;padding:0 10px;font-size: 12px;font-family: Source Han Sans CN;font-weight: 500;"><i style="width: 10px;height: 10px;background: #4FB2EA;border-radius: 50%;display:inline-block;margin-right:8px;"></i>' +
						// 			item.data.region +
						// 			' 成交价：' +
						// 			item.data.value +
						// 			'元 成交量：' +
						// 			item.data.volume +
						// 			'吨</span>';
						// 	}
						// });
						return tipText;
					},
				},
				legend: {
					width: 360,
					left: 0,
					// itemGap: 30,
					// orient: 'vertical',
					data: ['Email', 'Union Ads'],
					textStyle: { lineHeight: 10, padding: [0, 15, 0, 10] },
				},
				grid: {
					left: '3%',
					right: '8%',
					bottom: '12%',
					containLabel: true,
				},
				toolbox: {
					feature: {
						saveAsImage: {},
					},
				},
				xAxis: {
					type: 'category',
					boundaryGap: false,
					data: ['Mon', 'Tue'],
				},
				yAxis: {
					type: 'value',
				},
				dataZoom: [
					{
						type: 'inside',
						start: 80,
						end: 100,
					},
					{
						start: 0,
						end: 30,
					},
				],
				series: [
					{
						name: 'Email1',
						type: 'line',
						stack: 'Total',
						data: [
							{ value: '1', name: 'lisi' },
							{ value: '2', name: 'jack' },
							{ value: '100', name: 'john' },
						],
					},
					{
						name: 'Email2',
						type: 'line',
						stack: 'Total',
						data: [
							{ value: '1', name: 'lisi' },
							{ value: '2', name: 'jack' },
							{ value: '100', name: 'john' },
						],
					},
					{
						name: 'Email3',
						type: 'line',
						stack: 'Total',
						data: [
							{ value: '1', name: 'lisi' },
							{ value: '2', name: 'jack' },
							{ value: '100', name: 'john' },
						],
					},
				],
			};

			api.getRegionTransactionData({ yearDate: this.chooseYear }).then(
				(res) => {
					let series = res.data.series;
					let legend = res.data.legend;
					let xAxis = res.data.xAxis;
					let series2 = [];

					option.series = [];
					option.legend.data = [];
					option.xAxis.data = [];

					if (series.length > 0) {
						for (let i = 0; i < series.length; i++) {
							series2.push({
								smooth: true, //如果想折线图平滑可以加上这个属性
								name: series[i].name,
								type: 'line',
								// stack: 'Total',
								data: series[i].priceList,
							});
						}
					}

					option.series = series2;
					option.legend.data = legend;
					option.xAxis.data = xAxis;
					myChart.clear();
					option && myChart.setOption(option);
				}
			);
		},
		//获取碳排放交易数据-全国
		fetchEchartsDataKLines() {
			var chartDom = document.getElementById('article_r_echarts_Lines');
			var myChart = this.$echarts.init(chartDom);
			var option;
			const upColor = '#c23531';
			const upBorderColor = '#8A0000';
			const downColor = '#749f83';
			const downBorderColor = '#008F28';
			function calculateMA(dayCount) {
				var result = [];
				for (var i = 0, len = data0.values.length; i < len; i++) {
					if (i < dayCount) {
						result.push('-');
						continue;
					}
					var sum = 0;
					for (var j = 0; j < dayCount; j++) {
						sum += +data0.values[i - j][1];
					}
					result.push(sum / dayCount);
				}
				return result;
			}
			option = {
				// tooltip: {
				// 	trigger: 'axis',
				// 	axisPointer: {
				// 		type: 'cross',
				// 	},
				// },
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						animation: false,
						type: 'cross',
						// lineStyle: {
						// 	color: '#376df4',
						// 	width: 1,
						// 	opacity: 0.5,
						// },
					},
					formatter: function(param) {
						console.log(param);
						let params = param[0];
						return `${params.name}<br>${params.marker}开盘：${params.data[1]} 元/吨<br>${params.marker}收盘：${params.data[2]} 元/吨<br>${params.marker}最低：${params.data[3]} 元/吨<br>${params.marker}最高：${params.data[4]} 元/吨`;
					},
				},
				legend: {
					show: false,
					data: ['日K', '总量'],
					left: 0,
				},
				grid: {
					left: '3%',
					right: '10%',
					bottom: '12%',
					containLabel: true,
				},
				toolbox: {
					feature: {
						saveAsImage: {},
					},
				},
				xAxis: {
					type: 'category',
					data: [],
					boundaryGap: false,
					axisLine: { onZero: false },
					splitLine: { show: false },
					min: 'dataMin',
					max: 'dataMax',
				},
				yAxis: {
					scale: true,
					splitArea: {
						show: true,
					},
				},
				dataZoom: [
					{
						type: 'inside',
						start: 50,
						end: 100,
					},
					{
						show: true,
						type: 'slider',
						top: '90%',
						start: 50,
						end: 100,
					},
				],
				series: [
					{
						name: '日K',
						type: 'candlestick',
						data: [],

						itemStyle: {
							color: upColor,
							color0: downColor,
							borderColor: upBorderColor,
							borderColor0: downBorderColor,
						},
						markPoint: {
							label: {
								formatter: function(param) {
									return param != null
										? Math.round(param.value) + ''
										: '';
								},
							},
							data: [
								{
									name: 'Mark',
									coord: ['2013/5/31', 2300],
									value: 2300,
									itemStyle: {
										color: 'rgb(41,60,85)',
									},
								},
								{
									name: 'highest value',
									type: 'max',
									valueDim: 'highest',
								},
								{
									name: 'lowest value',
									type: 'min',
									valueDim: 'lowest',
								},
								{
									name: 'average value on close',
									type: 'average',
									valueDim: 'close',
								},
							],
							// tooltip: {
							// 	formatter: function(param) {
							// 		console.log(param);
							// 		return (
							// 			param.name +
							// 			'<br>' +
							// 			(param.data.coord || '')
							// 		);
							// 	},
							// },
						},
						markLine: {
							symbol: ['none', 'none'],
							data: [
								[
									{
										name: 'from lowest to highest',
										type: 'min',
										valueDim: 'lowest',
										symbol: 'circle',
										symbolSize: 10,
										label: {
											show: false,
										},
										emphasis: {
											label: {
												show: false,
											},
										},
									},
									{
										type: 'max',
										valueDim: 'highest',
										symbol: 'circle',
										symbolSize: 10,
										label: {
											show: false,
										},
										emphasis: {
											label: {
												show: false,
											},
										},
									},
								],
								{
									name: 'min line on close',
									type: 'min',
									valueDim: 'close',
								},
								{
									name: 'max line on close',
									type: 'max',
									valueDim: 'close',
								},
							],
						},
					},
					// {
					// 	name: '总量',
					// 	type: 'line',
					// 	data: calculateMA(5),
					// 	smooth: true,
					// 	lineStyle: {
					// 		opacity: 0.5,
					// 	},
					// },
					// {
					// 	name: '交易量',
					// 	type: 'line',
					// 	data: data0.solds,
					// 	markPoint: {
					// 		data: [
					// 			{ type: 'max', name: '最大值' },
					// 			{ type: 'min', name: '最小值' },
					// 		],
					// 	},
					// 	yAxisIndex: 2,
					// 	smooth: true,
					// 	lineStyle: {
					// 		normal: {
					// 			opacity: 0.5,
					// 		},
					// 	},
					// },
				],
			};
			api.getNationTransactionData(this.chooseYear).then((res) => {
				let data0 = this.splitData(res.data);
				option.series[0].data = data0.values;
				option.xAxis.data = data0.categoryData;
				//console.log(option);
				myChart.clear();
				option && myChart.setOption(option);
			});
		},
		splitData(rawData) {
			const categoryData = [];
			const values = [];
			for (var i = 0; i < rawData.length; i++) {
				categoryData.push(rawData[i].date);
				values.push([
					rawData[i].open,
					rawData[i].close,
					rawData[i].lowest,
					rawData[i].highest,
					rawData[i].turnover,
				]);
			}
			return {
				categoryData: categoryData,
				values: values,
			};
			// for (var i = 0; i < rawData.length; i++) {
			// 	categoryData.push(rawData[i].splice(0, 1)[0]);
			// 	values.push(rawData[i]);
			// }
			// return {
			// 	categoryData: categoryData,
			// 	values: values,
			// };
		},
		//判断是否有权限
		ifRightsFn() {
			return new Promise(function(resolve, reject) {
				api.weighterRights('2682').then((res) => {
					resolve(res.data);
				});
			});
		},
		clicktabfn(url, clickflag = false) {
			let _this = this;

			api.iflogin('').then((res2) => {
				function showData(val) {
					return val;
				}
				let res = eval(res2);

				if (!res.UserToken) {
					_this.$message.error('请先登录！');
					window.location.href =
						'http://d.drcnet.com.cn/eDRCNet.Common.Web/login/login.aspx?gourl=http://' +
						_this.urlHost +
						'/index.html#/Index';
				} else {
					_this.ifRightsFn().then((ress) => {
						if (!ress) {
							this.$message.error('您暂无权限，请先购买！');
							return;
						} else {
							if (clickflag) {
								const routeData = _this.$router.resolve({
									path: url,
								});
								console.log(routeData);

								window.open(routeData.href, '_blank');
							} else {
								_this.$router.push({ path: url });
								window.location.reload();
							}
						}
					});
				}
			});
		},
	},
};
</script>
<style lang="less" scoped>
.article_r_echarts_box {
	width: 487px;
	height: 335px;
	// margin-top: 30px;
}
.article_r_echarts_Lines {
	width: 487px;
	height: 335px;
}
.el-dropdown-my {
	position: absolute;
	z-index: 100;
	right: 30px;
	top: 58px;
}
// 下拉菜单样式
.el-dropdown-link {
	cursor: pointer;
	color: #439238;
	background: #ffffff;
	border-radius: 1px;
	border: 1px solid #4eac41;
	padding: 5px 10px;
}
.el-dropdown-menu--mini .el-dropdown-menu__item {
	font-size: 16px;
	margin: 10px 15px;
	max-height: 240px;
	overflow-y: none;
}
.el-dropdown-menu--mini .el-dropdown-menu__item:hover {
	color: #439238;
}
</style>



// WEBPACK FOOTER //
// src/view/index/components/kLines/index.vue